import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDenomination = ({ denominationId, isPublic }) => {
  if (isPublic) {
    return axios.get(`/denominations/${denominationId}/public`);
  }

  return axios.get(`/denominations/${denominationId}`);
};

export const useDenomination = ({
  denominationId,
  isPublic = false,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["denomination", denominationId],
    queryFn: () => getDenomination({ denominationId, isPublic })
  });
};
